import React from "react"
import SingleBlog from "../../components/Blogs/Home/SingleBlog"
import Blogs from "../../components/Blogs/Home/Blogs"

export default function HomePage() {
  return (
    <>
      <SingleBlog />
      <Blogs />
    </>
  )
}
